import { z } from 'zod';

const metadata = z.object({ id: z.string(), difficulty: z.number().int().min(1).max(5) });

export const parseQuestionDifficulty = (value: unknown, questionId: string) => {
  const question = metadata.parse(value);
  if (question.id !== questionId) throw new Error('Question metadata ID mismatch');
  return question.difficulty;
};
